import moment from 'moment';

export const getTodayRange = () => {
  return [moment().startOf('day'), moment().endOf('day')];
};

export const getLastThirtyDays = () => {
  return [moment().subtract(30, 'days'), moment()];
};

export const getLastMonth = () => {
  return [moment().subtract(1, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month')];
};

export const getThisYear = () => {
  return [moment().startOf('year'), moment().endOf('year')];
};

export const getRangeByDays = (days = 30) => {
  return [undefined, moment().subtract(days, 'days')];
};
